import { createSlice } from "@reduxjs/toolkit";
import {
  addCancelBooking,
  bookingCancel,
} from "./services/flightbookingcancellation.services";

const initialState: any = {
  loading: false,
  error: "",
};

const flightBookingCancellationSlice = createSlice({
  name: "flightbookingcancellation",
  initialState,
  reducers: {
    clearAdminSettingDetails: (state) => {
      state.addminsettingdetails = initialState.addminsettingdetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(bookingCancel.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(bookingCancel.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(bookingCancel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(addCancelBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(addCancelBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(addCancelBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export default flightBookingCancellationSlice.reducer;
